import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isBrowser } from './isBrowser';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent extends isBrowser {
	title = 'Gen-AI-Solution';

	constructor(@Inject(PLATFORM_ID) platformId: object) {
		super(platformId);
	}
}
